<template>
  <div id="tab-application" class="application">
    <div v-for="(record, i) in records" class="application__row" :key="i">
      <div class="application__question">
        <span>{{ i + 1 }}.</span>
        <div v-html="record.question.name"></div>
      </div>

      <div :class="['application__answer']">
        <a
          v-if="record.answer.type === 'file' && !!record.answer.content"
          :href="record.answer.content"
          download
          target="_blank"
          rel="noopener"
          >{{ $tr('responses.presentation.download') }}</a
        >
        <span
          v-else
          v-html="record.answer.content"
          v-tooltip.top-center="
            record.answer.is_dropped
              ? $tr('vacancy.preferences.application.addAnswers4')
              : ''
          "
          :class="{ application__answer_cut: record.answer.is_dropped }"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'tab-application',

    props: {
      records: Array
    },

    data() {
      return {};
    },

    computed: {},

    methods: {}
  };
</script>

<style lang="scss" scoped>
  .application {
    width: 100%;

    &__row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 22px;
      font-style: normal;
      font-weight: normal;
      font-size: 15px;
      line-height: 146.48%;
      letter-spacing: 0.005em;
      color: #233346;
    }
    &__question {
      display: flex;
      align-items: start;
      width: 295px;

      div {
        word-break: break-word;
      }

      ::v-deep p {
        margin: 0;
        // overflow-wrap: break-word;
      }
      ::v-deep a {
        word-break: break-all;
      }

      span {
        display: block;
        margin-right: 4px;
      }
    }
    &__answer {
      width: 450px;
      margin-left: 24px;
      color: #233346;

      ::v-deep p {
        margin: 0;
      }

      ::v-deep a {
        word-break: break-all;
        color: #233346;
      }

      .application__answer_cut {
        color: #f65046;
      }
    }
  }
</style>
